import {  useState } from "react";

const SupplierDateReadOnlyRow = ({ index, t, partnerDateItem, handleDeleteClick, oddIdx, 
									add, setIsEditMode, isEditMode, setError, handleSubmit, setEditableRecord, rowCount }) => {
    const [isSubmit, setIsSubmit] = useState(false);
    const today = new Date().toISOString().split("T")[0];
    let startDate = (add) ? today : partnerDateItem.startDate;
    let endDate = (add) ? "" : partnerDateItem.endDate;
    const [dates, setDates] = useState({ startDate: startDate, endDate: endDate });

    function submitComplete() {
        setIsSubmit(false);
    }

    function submitDelete(event, partnerDateItem) {
        setError("");
        setIsSubmit(true);
        handleDeleteClick(event, partnerDateItem, submitComplete);
    }

   const valueHandler = (e) => {
        const { name, value } = e.target;
        if (typeof value === 'undefined') {
            value = "";
        }
        setDates({ ...dates, [name]: value });
    }

    function handleEditClick(event) {
        //event.preventDefault();
        //event.stopPropagation();
        if(add){
			setError(t("error.onlyOneOpAllowed"));
		} else {
			setIsSubmit(false);
        	setIsEditMode(true);
        	setEditableRecord(rowCount);
		}
    }

    function submitUpdate(event, partnerDateItem) {
        //event.preventDefault();
        //event.stopPropagation();
        setError("");
        setIsSubmit(true);
        let updatedValues = {
			partnershipDateKey: partnerDateItem.partnershipDateKey,
            partnershipKey: partnerDateItem.partnershipKey,
          	startDate: dates.startDate,
            endDate: dates.endDate,
        };
        handleSubmit(2, updatedValues, submitUpdateComplete);
    }
    function submitUpdateComplete() {
        setIsSubmit(false);
        setIsEditMode(false);
    }
    function submitCancel(event, partnerDateItem) {
        //event.preventDefault();
        //event.stopPropagation();
        setError("");
        dates.startDate = partnerDateItem.startDate;
        dates.endDate = partnerDateItem.endDate;
        setIsEditMode(false);
        setIsSubmit(false);
    }
    return (
        <tr key={index}>
            {isEditMode ? (
                <>
                	<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
	                <input
                        type="date"
                        name="startDate"
                        id="startDate"
                        min="2000-01-01"
                        value={dates.startDate || today}
                        onChange={valueHandler}
                        className="form-control rounded-pill shadow-sm px-4 "
                    />
                	</td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                        <input
	                        type="date"
	                        name="endDate"
	                        id="endDate"
	                        min="2000-01-01"
	                        value={dates.endDate}
	                        onChange={valueHandler}
	                        className="form-control rounded-pill shadow-sm px-4 "
	                    />
                    </td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{partnerDateItem.status}</td>
                </>


            ) : (
                <>
                	<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{"" + partnerDateItem.startDate}</td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{"" + partnerDateItem.endDate}</td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{partnerDateItem.status}</td>
                </>
            )}

            <td className={oddIdx ? "list-td col col-md-auto odd" : "list-td col col-md-auto even"}>
                <div id="submit-spinner"
                    className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
                >
                </div>
                {isEditMode ? (
                    <>
                        <button className={isSubmit ? "btn btn-primary btn-block me-2 mb-1 pe-none" : "btn btn-primary btn-block me-2 mb-1"}
                            onClick={(event) => submitUpdate(event, partnerDateItem)}>{t("page.submit")}</button>
                        <button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"}
                            onClick={(event) => (submitCancel(event, partnerDateItem))}>{t("page.cancel")}</button>
                    </>
                ) : (
                    <>
                        <button className={isSubmit ? "btn btn-primary btn-block me-2 mb-1 pe-none" : "btn btn-primary btn-block me-2 mb-1"}
                            onClick={(event) => handleEditClick(event)}>{t("page.edit")}</button>
                        <button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-2 mb-1"} onClick={(event) => submitDelete(event, partnerDateItem)}>
                            {partnerDateItem.statusCode === 1 ? t("page.delete") : t("page.undelete")}</button>
                    </>
                )}

            </td>
        </tr>
    )
}
export default SupplierDateReadOnlyRow;